import { uid } from '../../../../lib/uid';

const KINDS = [
  'Professional licence',
  'Driver licence',
  'Passport',
  'Voter identification',
  'Postal identification',
  'PhilSys number',
];

/**
 * A sample identification type, so the create form fills in one click.
 *
 * The name is suffixed because it is unique among active rows: Autogenerate is most useful
 * clicked repeatedly, and without a suffix the second click produces a name the server rejects
 * as a duplicate.
 *
 * Synthetic vocabulary rather than a real agency's scheme — these rows decide what every future
 * personnel record can be asked for, so a generated one should be obviously disposable.
 */
export function sampleIdentificationType(): {
  name: string;
  code: string;
  description: string;
} {
  const tag = uid().slice(0, 4).toUpperCase();
  const kind = KINDS[Math.floor(Math.random() * KINDS.length)];

  return {
    name: `${kind} ${tag}`,
    code: tag,
    description: `Sample identification type ${tag}. Delete it once the real list is in.`,
  };
}
